// ENTITY fr.gestionpial.user.dto.GestionPialBundle generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { GestionPialUser } from './GestionPialUser';

export class GestionPialBundle {

  static readonly __ic2_fqn: string = 'fr.gestionpial.user.dto.GestionPialBundle';

  gestionPialUser: GestionPialUser | null = null;
  tokenExpiration: Date | null = null;

  constructor(init?:Partial<GestionPialBundle>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.user.dto.GestionPialBundle'] = GestionPialBundle;

fields['fr.gestionpial.user.dto.GestionPialBundle']  = {
    gestionPialUser: 'fr.gestionpial.user.entities.GestionPialUser',
    tokenExpiration: 'java.time.Instant'
};
